import AppLoginPage from '../../components/app-customer-login-page/app-customer-login-page';
import AppSettingsPage from '../../components/app-customer-settings-page/app-customer-settings-page';
import AppDashboardPage from '../../components/app-dashboard-page/app-dashboard-page';
import { ROUTES } from './constants';

export const filterApplicationPage = () => {
    const currentUrl = window.location.href;
    const route = Object.values(ROUTES).find(el => currentUrl.includes(el.route));
    return route && route.key ? route.key : ROUTES.DASHBOARD.key;
};

export const getApplication = (actualPage) => {
    switch (actualPage) {
    case ROUTES.DASHBOARD.key:
        return AppDashboardPage;
    case ROUTES.LOGIN.key:
        return AppLoginPage;
    case ROUTES.SETTINGS.key:
        return AppSettingsPage;
    default:
        return AppDashboardPage;
    }
};
